import { Link } from 'react-router-dom';
import { shopByFunctionCategories } from '@/mocks/products';

export default function ShopByFunction() {
  return (
    <section className="bg-secondary-100 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
            Built for Every Kind of Play
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">From dental health to mental enrichment — find the right toy for the job</p>
        </div>

        <div className="flex gap-3 md:gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide snap-x snap-mandatory">
          {shopByFunctionCategories.map(cat => (
            <Link
              key={cat.id}
              to={`/shop?function=${cat.id}`}
              className="flex-shrink-0 w-[220px] md:w-[240px] snap-start bg-background-50 rounded-2xl p-5 card-hover-lift group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${cat.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-800 mb-1.5">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
              <div className="mt-4 flex items-center gap-1.5 text-accent-500 text-xs font-semibold group-hover:gap-2 transition-all duration-200">
                Explore
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
}